import { render, staticRenderFns } from "./quesInstru1.vue?vue&type=template&id=3814bf33"
import script from "./quesInstru1.vue?vue&type=script&lang=js"
export * from "./quesInstru1.vue?vue&type=script&lang=js"
import style0 from "./quesInstru1.vue?vue&type=style&index=0&id=3814bf33&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports